<div class="col-md-12"
    style="box-shadow: 3px 3px 33px 6px #7500C0; height: 35vw;background: linear-gradient(141deg, #fafafa 20%, #fafafa 65%);">
    <div class="row">
        <div class="col-lg-12">
            <h3 class="page-header" style="color: #000000;"><i class="fa fa-laptop"></i>Feedback Dashboard</h3>
        </div>
    </div>

    <div class="row">
        <div style="width:100%;" align="center">

            <div class="panel panel-default" *ngIf="showFeedbackMainDashboard">
                <div class="panel panel-heading"
                    style="background: linear-gradient(141deg, #460073 20%, #A100FF 65%); font-weight: bold; margin-top: -3%; color: white; width:100.4%; margin-left:-2px">
                    Employee's Voice</div>
                <div class="panel-body" style="height: 300px; margin-bottom: 20px;margin-top: -2px;">
                    <table style="min-width: 250px;">
                        <tr>
                            <td>
                                <table>
                                    <tr>
                                        <td style="padding-bottom: 15%; " *ngFor="let data of successfulData.feedbacks">
                                            <table class=" table1" cellpadding="0" cellspacing="0"
                                                style="border-width: 0px medium 0px 0px; border-style: solid; border-color: white; border-image: none; min-height: 150px; ">
                                                <tr>
                                                    <td>
                                                        <div style="margin-left: 1%; max-height: 85px;">
                                                            <!-- <img alt="" src="{{data.ProfilePicURL}}" class="img-circle" style="width:65px;height:65px;"> -->
                                                            <img alt="" src="assets/img/People_Circle.PNG" class="img-circle" style="width:65px;height:65px;">
                                                            <br />
                                                            <span
                                                                style="color: #000000; font-family: Arial; font-weight: bold; font-size: 12pt; ">
                                                                {{data.EnterpriseID}} <br />
                                                            </span>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div class="comment" id="feedbackDisp"
                                                            style="margin-left: 1.5%;">
                                                            {{data.SuggestionFeedback}}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div *ngIf="showMsgFeedbackMainDashboard">
            <label style="color: #000000; font-weight: bold; font-size: 15px;margin-left: 10px;">We didn't find
                any data to
                display. Please contact the Online support or check User Guidelines section for any access or tool
                issue.</label>
        </div>
    </div>
</div>

<!-- <script type="text/javascript">
    $(document).ready(function () {
        if (($('#feedbackDisp')).length > 100) {
            $(".comment").shorten({
            });
        }
    });    
</script> -->